






import Vue from "vue";
import { DownloadLongTaskResultCommand } from "@/model/communication/userLongTasks/DownloadLongTaskResultCommand";

export default Vue.extend({
    data() {
        return {
            loading: false,
        };
    },
    props: {
        path: {
            type: String,
            required: true,
        },
        method: {
            type: String,
            default: "get",
        },
    },
    methods: {
        async onDownloadClick() {
            this.loading = true;

            try {
                let res = null;
                if (this.path.includes("user_long_task")) {
                    res = await new DownloadLongTaskResultCommand(this.path.split("/").slice(-1)).execute();
                }
                if (res && res.data) {
                    let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.$emit("downloaded");
                }
            } catch (err) {
                console.error(err);
            }

            this.loading = false;
        },
    },
});
